export default __webpack_public_path__ + "static/media/6.a32b3784.png";